import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import { Button, Row } from 'reactstrap';
import { CSVLink } from 'react-csv';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCsv } from '@fortawesome/free-solid-svg-icons';

//Context
import { useAuth } from '../../../context/auth';

//Components
import CardRelatorio from '../components/CardRelatorio';
import MainCard from '../../../components/MainCard/MainCard';

//Helpers
import mascaras from '../../../helpers/mascaras';

function RelatorioTransportadores({ btnVoltar, filtros, dadosRelatorio }) {
  const { setupVariavel, session } = useAuth();

  const [dados, setDados] = useState([])

  //Referencia do relatorio para impressão pdf
  const refRelatorio = useRef(null);

  //Referencia do relatorio para download do csv
  const exportRef = useRef(null);

  //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
  const headersTransportadores = [
    { value: "Razão Social", objectValue: "fantasia", col: "12" },
    { value: "CNPJ", objectValue: "cnpj", col: "6" },
    { value: "Telefone", objectValue: "fone", col: "6" },
    { value: "Endereço", objectValue: "endereco", col: "12" },
    { value: "Status", objectValue: "status", col: "6" },
    { value: "Validade", objectValue: "validade", col: "6" },
    { value: "Código Cadastro", objectValue: "credenciamentoNumero", col: "12" },
    { value: "Modalidades", objectValue: "modalidades", col: "12" },
  ];

  const headersCSV = [
    { label: "Razão Social", key: "fantasia" },
    { label: "CNPJ", key: "cnpj" },
    { label: "Telefone", key: "fone" },
    { label: "Endereço", key: "endereco" },
    { label: "Status", key: "status" },
    { label: "Validade", key: "validade" },
    { label: "Código Cadastro", key: "credenciamentoNumero" },
    { label: "Modalidades", key: "modalidades" },
  ];

  //Função assionada assim que o botão de imprimir pdf é clicado
  const handlePrint = useReactToPrint({
    content: () => refRelatorio.current,
    copyStyles: true,
    documentTitle: "Relatório dos transportadores",
  });

  //Botão de exportação csv
  const BtnExportCsv = () => {
    return (
      <Button className='mb-3' color='success' onClick={() => exportRef.current.link.click()}>
        <FontAwesomeIcon icon={faFileCsv} /> Gerar CSV
      </Button>
    )
  }

  useEffect(() => {
    if (dadosRelatorio?.length > 0) {
      setDados([...dadosRelatorio.map(value => {
        value.cnpj = mascaras.cpfcnpjMask(value.cnpj)
        return value;
      })])
    }
  }, []);

  return (
    <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint} BtnAction1InTop={BtnExportCsv}>
      <CSVLink
        separator={";"}
        data={dados}
        headers={headersCSV}
        filename="Relatorio de transportadores.csv"
        target="_blank"
        ref={exportRef}
      />
      <div className="mt-4 relatorio w-100" ref={refRelatorio}>
        <div className="print m-2 d-flex align-items-center justify-content-between">
          <p>Emitido por: {session.nome}</p>
          <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
        </div>
        {setupVariavel?.logoTipo &&
          <div className="d-flex align-items-center justify-content-center">
            <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%' }} />
          </div>
        }
        <div className="header">
          <h4 className='text-black'>Relatório dos Transportadores</h4>
          <Row>
            <div className='col-6'>
              {filtros.modalidadeId_selected && <p><span className="fw-bold">Modalidade:</span> {filtros.modalidadeId_selected.label}</p>}
            </div>
            <div className='col-6'>
              {filtros.status && <p><span className="fw-bold">Status:</span> {filtros.status}</p>}
            </div>
          </Row>
        </div>
        <div className="body">
          <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>Dados Transportadores</h5>
          <CardRelatorio
            headers={headersTransportadores}
            items={dados}
          />
        </div>
      </div>
    </MainCard>
  );
}

export default RelatorioTransportadores;